import type { GlyphColor, IconName } from "../components/tk";

export type NavItem = {
  key: string;
  to: string;
  label: string;
  icon: IconName;
  color: GlyphColor;
  /** Primary sections (Home, Approvals, Copilot, Ads, Campaigns). */
  primary?: boolean;
  /** Phone bottom tab. */
  tab?: boolean;
  /** Hidden for client viewers. */
  staff?: boolean;
  keywords?: string;
};

export const NAV: NavItem[] = [
  { key: "home", to: "/", label: "Home", icon: "home", color: "blue", primary: true, tab: true, keywords: "overview dashboard digest" },
  { key: "approvals", to: "/approvals", label: "Approvals", icon: "inbox", color: "orange", primary: true, tab: true, staff: true, keywords: "plans pending diff approve" },
  { key: "copilot", to: "/copilot", label: "Copilot", icon: "sparkles", color: "purple", primary: true, tab: true, staff: true, keywords: "chat ask ai" },
  { key: "ads", to: "/ads", label: "Ads", icon: "megaphone", color: "red", primary: true, tab: true, keywords: "ads table cpm pause" },
  { key: "campaigns", to: "/campaigns", label: "Campaigns", icon: "target", color: "green", primary: true, keywords: "autopilot launch wizard" },
  { key: "rules", to: "/rules", label: "Rules", icon: "flow", color: "teal", staff: true, keywords: "automation conditions" },
  { key: "agents", to: "/agents", label: "Agents", icon: "robot", color: "indigo", staff: true, keywords: "night watch auditor treasurer runs findings" },
  { key: "attribution", to: "/attribution", label: "Attribution", icon: "chart", color: "pink", keywords: "roas retention sdk revenue" },
  { key: "channels", to: "/channels", label: "Channels", icon: "channel", color: "blue", keywords: "lookalikes database joins" },
  { key: "agency", to: "/agency", label: "Agency", icon: "briefcase", color: "yellow", staff: true, keywords: "clients reports share transfers" },
  { key: "billing", to: "/billing", label: "Billing", icon: "wallet", color: "green", staff: true, keywords: "balance plan runway ledger" },
  { key: "settings", to: "/settings", label: "Settings", icon: "gear", color: "gray", keywords: "members notifications emergency pause" },
];

export function activeKey(pathname: string): string {
  if (pathname === "/" || pathname === "") return "home";
  const seg = pathname.split("/")[1] ?? "";
  if (seg === "more" || seg === "notifications") return seg;
  return NAV.find((n) => n.to === `/${seg}`)?.key ?? "";
}
